import { Component, Input, Output, EventEmitter } from '@angular/core';
import { VideoItemComponent } from 'src/app/@core/models/item-component';
import { FileService } from 'src/app/@core/services/file.service';
import { FirebaseApp } from '@angular/fire';
import { HttpResponse } from '@angular/common/http';
import { TranslateSharedModule } from 'src/app/translate/translate.module';

@Component({
  selector: 'app-editor-component-text-config',
  templateUrl: 'text-config.component.html',
  styleUrls: ['../text.component.scss']

})
export class EditorTextConfigComponent {
  @Input() item: VideoItemComponent;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  public isFullscreen: boolean = false;

  public quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['clean'],
      ['link', 'image', 'video']
    ]
  };

  public quillEditorRef: any;

  getEditorInstance(editorInstance: any) {
    this.quillEditorRef = editorInstance;
    const toolbar = editorInstance.getModule('toolbar');
    toolbar.addHandler('image', () => {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (file) {
          this.fileService.uploadFile({ file: file }).subscribe((event: any) => {
            if (event instanceof HttpResponse) {
              const url = event.body.data.url;
              const range = this.quillEditorRef.getSelection(true);
              this.quillEditorRef.insertEmbed(range.index, 'image', url);
            }
          });
        }
      };
    });
  }

  constructor(
    public fileService: FileService,
    private translateService: TranslateSharedModule
  ) {

  }

  setAlign(element: any, align: string) {
    element.align = align;
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }
}
